import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { useTranslation } from "react-i18next";


import "swiper/css";

const TeamMembers = () => {
  const { t } = useTranslation("team"); // Hook to use translations

  return (
    <div className="container-class p-5 sm:p-[100px] ellipsebg">
      <div className="flex flex-col items-start gap-5 pb-10">
        <div className="max-w-[631px]">

          <h1 className="web-heading-section">
            {t("meet_the_people_behind_vision")}
          </h1>
        </div>
        <p className="text-[#F0F0F0B2] text-[18px] font-normal leading-[30px]">
          {t("join_our_team_future_of_mining")}
        </p>
      </div>

      <Swiper
        spaceBetween={16}
        slidesPerView={1} // Default for small screens
        breakpoints={{
          640: {
            slidesPerView: 2, // 2 cards on medium screens (>=640px)
            spaceBetween: 16, // Space between slides
          },
          1024: {
            slidesPerView: 3.5, // 3.5 cards on larger screens (>=1024px)
            spaceBetween: 16,
          },
        }}
        onSlideChange={() => console.log("slide change")}
        onSwiper={(swiper) => console.log(swiper)}
      >
        <SwiperSlide>
          <div className="relative p-8 rounded-[20px] backdrop-blur-[10px] cardsbg1 w-full h-[352px] overflow-hidden group">
            {/* Gradient Overlay on Hover */}
            {/* Card Content */}
            <div className="relative z-10 flex flex-col justify-between h-full">
              <div className="flex flex-col gap-3">
                <h1 className="text-[24px] font-medium leading-8 text-[#EEEEEE]">
                  {t("team_member_1")}
                </h1>
                <p className="text-[16px] font-light leading-5 text-[#EEEEEE99]">
                  {t("job_title_1")}
                </p>
                <div className="border border-[#05897E] px-[15px] py-[5px] text-[#42FBFE] font-medium text-[14px] leading-[23.8px] rounded-full flex items-center justify-center w-[112px]">
                  {t("employment_type_full_1")}
                </div>
              </div>
              <div className="flex justify-end items-end">
                <button>
                  <img src="/assets/link.svg" alt="Link Icon" />
                </button>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="relative p-8 rounded-[20px] backdrop-blur-[10px] cardsbg2 w-full h-[352px] overflow-hidden group">
            {/* Gradient Overlay on Hover */}

            {/* Card Content */}
            <div className="relative z-10 flex flex-col justify-between h-full">
              <div className="flex flex-col gap-3">
                <h1 className="text-[24px] font-medium leading-8 text-[#EEEEEE]">
                  {t("team_member_1")}
                </h1>
                <p className="text-[16px] font-light leading-5 text-[#EEEEEE99]">
                  {t("job_title_2")}
                </p>
                <div className="border border-[#05897E] px-[15px] py-[5px] text-[#42FBFE] font-medium text-[14px] leading-[23.8px] rounded-full flex items-center justify-center w-[112px]">
                  {t("employment_type_full_2")}
                </div>
              </div>
              <div className="flex justify-end items-end">
                <button>
                  <img src="/assets/link.svg" alt="Link Icon" />
                </button>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="relative p-8 rounded-[20px] backdrop-blur-[10px] cardsbg3 w-full h-[352px] overflow-hidden group">
            {/* Gradient Overlay on Hover */}

            {/* Card Content */}
            <div className="relative z-10 flex flex-col justify-between h-full">
              <div className="flex flex-col gap-3">
                <h1 className="text-[24px] font-medium leading-8 text-[#EEEEEE]">
                  {t("team_member_1")}
                </h1>
                <p className="text-[16px] font-light leading-5 text-[#EEEEEE99]">
                  {t("job_title_3")}
                </p>
                <div className="border border-[#05897E] px-[15px] py-[5px] text-[#42FBFE] font-medium text-[14px] leading-[23.8px] rounded-full flex items-center justify-center w-[112px]">
                  {t("employment_type_full_3")}
                </div>
              </div>
              <div className="flex justify-end items-end">
                <button>
                  <img src="/assets/link.svg" alt="Link Icon" />
                </button>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="relative p-8 rounded-[20px] backdrop-blur-[10px] cardsbg4 w-full h-[352px] overflow-hidden group">
            {/* Gradient Overlay on Hover */}

            {/* Card Content */}
            <div className="relative z-10 flex flex-col justify-between h-full">
              <div className="flex flex-col gap-3">
                <h1 className="text-[24px] font-medium leading-8 text-[#EEEEEE]">
                  {t("team_member_2")}
                </h1>
                <p className="text-[16px] font-light leading-5 text-[#EEEEEE99]">
                  t{t("job_title_4")}
                </p>
                <div className="border border-[#05897E] px-[15px] py-[5px] text-[#42FBFE] font-medium text-[14px] leading-[23.8px] rounded-full flex items-center justify-center w-[112px]">
                  {t("employment_type_full_4")}
                </div>
              </div>
              <div className="flex justify-end items-end">
                <button>
                  <img src="/assets/link.svg" alt="Link Icon" />
                </button>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="relative p-8 rounded-[20px] backdrop-blur-[10px] cardsbg1 w-full h-[352px] overflow-hidden group">
            {/* Gradient Overlay on Hover */}

            {/* Card Content */}
            <div className="relative z-10 flex flex-col justify-between h-full">
              <div className="flex flex-col gap-3">
                <h1 className="text-[24px] font-medium leading-8 text-[#EEEEEE]">
                  {t("team_member_3")}
                </h1>
                <p className="text-[16px] font-light leading-5 text-[#EEEEEE99]">
                  {t("job_title_5")}
                </p>
                <div className="border border-[#05897E] px-[15px] py-[5px] text-[#42FBFE] font-medium text-[14px] leading-[23.8px] rounded-full flex items-center justify-center w-[112px]">
                  {t("employment_type_full_5")}
                </div>
              </div>
              <div className="flex justify-end items-end">
                <button>
                  <img src="/assets/link.svg" alt="Link Icon" />
                </button>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="relative p-8 rounded-[20px] backdrop-blur-[10px] cardsbg2 w-full h-[352px] overflow-hidden group">
            {/* Gradient Overlay on Hover */}

            {/* Card Content */}
            <div className="relative z-10 flex flex-col justify-between h-full">
              <div className="flex flex-col gap-3">
                <h1 className="text-[24px] font-medium leading-8 text-[#EEEEEE]">
                  {t("team_member_4")}
                </h1>
                <p className="text-[16px] font-light leading-5 text-[#EEEEEE99]">
                  {t("job_title_6")}
                </p>
                <div className="border border-[#05897E] px-[15px] py-[5px] text-[#42FBFE] font-medium text-[14px] leading-[23.8px] rounded-full flex items-center justify-center w-[112px]">
                  {t("employment_type_full_6")}
                </div>
              </div>
              <div className="flex justify-end items-end">
                <button>
                  <img src="/assets/link.svg" alt="Link Icon" />
                </button>
              </div>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default TeamMembers;
